/** @jsx jsx */

import { jsx } from '@emotion/core';

import { Dropdown } from '@zapier/design-system';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  onChange: (value: SemVer) => void;
  size: 'small' | 'medium';
  version: SemVer;
  versions: SemVer[];
};

function VersionDropdown(props: Props) {
  const { onChange, size, version, versions } = props;

  return (
    <Dropdown
      aria-label="Version"
      getLabelForItem={item => item.label}
      items={versions.map(v => ({ label: `Version ${v}`, value: v }))}
      menuAriaLabel="List of available versions"
      onSelect={({ value }) => onChange(value)}
      placeholder="Choose a version"
      selectedItem={{ label: `Version ${version}`, value: version }}
      size={size}
    />
  );
}

VersionDropdown.defaultProps = {
  size: 'small',
};

export default VersionDropdown;
